/* eslint-disable react/no-multi-comp */
/* eslint-disable max-classes-per-file */
import React, { Component, PureComponent } from 'react';
import T from 'prop-types';
import Heading from '@splunk/react-ui/Heading';
import Markdown from '@splunk/react-ui/Markdown';
import JSONTree from '@splunk/react-ui/JSONTree';
import styled from 'styled-components';

const EventTester = styled.div`
    margin-top: 50px;
`;

const Event = styled.div`
    margin-top: 20px;
`;
const EventName = styled.div`
    color: #5ca300;
    padding-bottom: 5px;
`;

const EventItem = ({ name, desc }) => (
    <Event>
        <EventName>{name}</EventName>
        <Markdown style={{ marginLeft: 40 }} text={desc} />
    </Event>
);

EventItem.propTypes = {
    name: T.string,
    desc: T.string,
};

const EventsDesc = ({ events }) => (
    <div>
        {events.length === 0 ? <Heading level={4}>No Events</Heading> : <Heading level={4}>Events</Heading>}
        {events.map(e => (
            <EventItem key={e.name} {...e} />
        ))}
    </div>
);

EventsDesc.propTypes = {
    events: T.array.isRequired,
};

class VisExample extends PureComponent {
    render() {
        const { options = {}, Visualization, encoding, dsState, onEventTrigger } = this.props;
        return (
            <EventTester>
                <Heading level={4}>Test Visualization</Heading>
                <Visualization
                    options={options}
                    dataSources={dsState}
                    onEventTrigger={onEventTrigger}
                    encoding={encoding}
                    hasEventHandlers
                />
            </EventTester>
        );
    }
}

VisExample.propTypes = {
    options: T.object,
    Visualization: T.any,
    dsState: T.object,
    onEventTrigger: T.func,
    encoding: T.object,
};

const EventExample = ({ event }) => {
    const eventToDisplay = {
        ...event,
    };
    if (eventToDisplay.originalEvent != null) {
        eventToDisplay.originalEvent = '...Original Event instance...';
    }

    return (
        <React.Fragment>
            <Heading level={4}>Event Monitor</Heading>
            <div>
                <JSONTree json={eventToDisplay} expandChildren />
            </div>
        </React.Fragment>
    );
};

EventExample.propTypes = {
    event: T.object,
};

class EventsDoc extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            e: null,
        };
    }

    handleEvent = e => {
        this.setState({
            e,
        });
    };

    render() {
        return (
            <div>
                <EventsDesc events={this.props.events} />
                <VisExample {...this.props} onEventTrigger={this.handleEvent} />
                <EventExample event={this.state.e} />
            </div>
        );
    }
}

EventsDoc.propTypes = {
    options: T.object,
    events: T.array,
    dsState: T.object,
    Visualization: T.any,
    encoding: T.object,
};

export default EventsDoc;
